import type { RestaurantOnboardingStage } from '.';

// Production hid the footer from the outside with `footerStyles`; the new Modal API no longer has it,
// and ModalContent renders the footer container for any truthy `footer`, even when that footer renders null.
// Without this condition, the "this restaurant already exists" screen shows a primary CTA that
// handleContinue does not handle, and the other three states keep an empty bordered strip.
//
// Lives in its own module (rather than in index.tsx) so the unit test can import it without pulling the
// whole modal tree in, which reaches react-markdown (ESM) and cannot be parsed by Jest.
export const shouldShowOnboardingFooter = (activeUI: RestaurantOnboardingStage, isInputFilled: boolean) =>
  !(
    activeUI === 'magic_ai_loading' ||
    // Explicit equality rather than `includes('already_exists')`: a substring match would silently hide the
    // footer for any future stage whose name happens to contain it, which is the same shape of defect this
    // change exists to remove.
    activeUI === 'restaurant_already_exists' ||
    activeUI === 'contact_already_exists' ||
    activeUI === 'restaurant_onboarding_successfull' ||
    (activeUI === 'select_restaurant_from_google' && !isInputFilled)
  );
